<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>Posters</h1>
    <div class="head-div">
      <div class="search-wrapper">
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search Posters"
          (input)="onSearch($event)"
        />
      </div>
      <button
        *appHasPermission="'ADD_POSTER'"
        class="cmn-add-btn"
        (click)="navigateTo('poster/new')"
      >
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Poster
      </button>
    </div>
  </div>
  <div class="itemListWrapper" *ngIf="!loading">
    <div class="itemWrapper" *ngFor="let story of storyList">
      <div class="story-img-wrapper">
        <img
          [src]="story.image || '../../../assets/images/placeHolderImage.jpg'"
          alt="Poster Image"
          (error)="onImageError($event)"
        />
      </div>
      <h3 class="cmn-list-title">
        {{ getPreferredTitle(story.posterTranslations).slice(0, 30) }}
      </h3>
      <div class="action-Container">
        <div class="action-wrapper">
           <div
            *appHasPermission="'UPDATE_STORY'"
           (click)="openDialog(story)"
            class="iconWrapper" >
            <img src="../../../assets/images/icons/view.svg" alt="" />
          </div>
          <div
            *appHasPermission="'UPDATE_POSTER'"
            class="iconWrapper"
            (click)="onPosterEdit(story?.id)"
          >
            <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
          </div>
          <div
            *appHasPermission="'DELETE_POSTER'"
            class="iconWrapper"
            (click)="onDeletePoster(story?.id)"
          >
            <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="noData">
    <app-no-data-component></app-no-data-component>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
